import styled from 'styled-components';

const TabRow = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 1rem;
  border-bottom: 1px solid #dfe5e9;
`;

const TabButton = styled.button`
  flex: 1;
  padding: 0.5rem 0.25rem 0.625rem;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 0.8125rem;
  font-weight: 600;
  color: ${(props) => (props.$active ? '#0a819f' : '#666666')};
  border-bottom: 3px solid
    ${(props) => (props.$active ? '#0a819f' : 'transparent')};
  margin-bottom: -1px;
  transition: color 0.15s ease;

  &:hover {
    color: #0a819f;
  }
`;

export default function ModeToggle({ myFiltersActive, onToggle }) {
  return (
    <TabRow role="tablist" aria-label="Tip sheet scope">
      <TabButton
        type="button"
        role="tab"
        aria-selected={!myFiltersActive}
        $active={!myFiltersActive}
        onClick={() => onToggle(true)}
      >
        All Tip Sheets
      </TabButton>
      <TabButton
        type="button"
        role="tab"
        aria-selected={myFiltersActive}
        $active={myFiltersActive}
        onClick={() => onToggle(false)}
      >
        My Filters
      </TabButton>
    </TabRow>
  );
}
